import * as React from "react";
import { FC, useRef } from "react";
import { Feature } from "ol";
import { MiniMapButton } from "./miniMapButton";
import { useDestinationMiniMap } from "./useDestinationMiniMap";

export type OnMiniFeatureClickCallback = ({ layerId, objectId }: { layerId: string; objectId: string }) => void;

export interface IDestinationMiniMap {
    /**
     * (Required) All destination features
     */
    destinationList: Feature[];
    /**
     * callback on object click, returns identified object, as { layerId: string; objectId: string }
     */
    onClickOnMiniFeature: OnMiniFeatureClickCallback;
    /**
     * string, representing Destination OBJECTID
     */
    destinationId: string;
}

export const DestinationMiniMap: FC<IDestinationMiniMap> = (props: IDestinationMiniMap) => {
    const ref = useRef<HTMLDivElement>();
    const map = useDestinationMiniMap(ref, props);

    return (
        <div ref={ref} style={{ width: "100%", height: "100%", display: "block", position: "relative" }}>
            <MiniMapButton
                onClick={(id) => props.onClickOnMiniFeature({ layerId: "clusterLayer", objectId: id })}
                id={props.destinationId}
            />
        </div>
    );
};
